import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConvenioService } from 'src/app/services/convenio/convenio.service';
import { BoletoService } from 'src/app/services/convenio/boleto.service';
import { TransportistaService } from 'src/app/services/convenio/transportista.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import * as moment from 'moment';
@Component({
  selector: 'app-boletaje',
  templateUrl: './boletaje.component.html',
  styleUrls: ['./boletaje.component.scss']
})
export class BoletajeComponent implements OnInit {

  @Input() dataTransportistas:any
  convenios:any;
  convenioSeleccionado:any;
  dataTarifas: any;
  saldo=0.00;
  user: any;
  total=0.0;
  boletos=[];
  idTransportista=0;
  dataFormBoletos = [];
  id_scct_convenio=0;
  operacionValida=false;
  isOpenModal: boolean = false;
  modalPDFBoletos: boolean = false;
  constructor(
    private transportistaService: TransportistaService,
    private conveniService: ConvenioService,
    private boletoService: BoletoService,
    private router: Router,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private ngxUiLoaderService: NgxUiLoaderService,
  ) {

  }
  ngOnInit(): void {
    this.store.select(selectUser).subscribe(user => this.user = user);
    this.getData();
  }

  getData() {
    this.ngxUiLoaderService.start()


    // this.transportistaService.getTransportistas().
    //   subscribe(data => {
    //     this.dataTransportistas = data;
    // })
    this.boletoService.getTarifas().
      subscribe(data => {
        this.dataTarifas = data;
    })
    this.ngxUiLoaderService.stop()
  }
  consultarConvenionios(transportista: any) {
    var id_transportista=Number(transportista.target.value);
    if(id_transportista>0){
      this.conveniService.getConveniosByTransportista(id_transportista ).
        subscribe((data):any=> {
          this.convenios = data;
        })
    }else{
      this.convenios = [];
    }

  }
  seleccionarConvenio(convenio){
    var id_convenio=Number(convenio.target.value);
    if(id_convenio>0){
      this.convenioSeleccionado=this.convenios.find( item =>item.id==(id_convenio));
        this.saldo=this.convenioSeleccionado.saldo;
        this.id_scct_convenio=this.convenioSeleccionado.id;
    }else{
      this.convenioSeleccionado=null;
      this.saldo=0.00;
    }
    this.compararTotalSaldoaFavor(this.total,this.saldo);
  }
  openModal(tipo: number){
    this.isOpenModal = !this.isOpenModal;

  }
  saveBoletos() {
    let data = {
      boletos : this.dataFormBoletos,
      id_scct_convenio : this.id_scct_convenio,
      id_usuario_creador : this.user.id,
      total : this.total
    }
    console.log(data);

    if (this.id_scct_convenio==0) {
      return this.toastr.error(`Seleccione el convenio`, '', { positionClass: 'toast-bottom-right' });
    }

    if (this.total > Number(this.saldo)) {
      return this.toastr.error(`No cuentas con el saldo suficiente`, '', { positionClass: 'toast-bottom-right' });
    }
    this.ngxUiLoaderService.start();
    this.compararTotalSaldoaFavor(this.total,this.saldo);

    this.ngxUiLoaderService.start('2');
    let urlExcel:string;
    if(this.operacionValida){
      this.boletoService.saveBoleto(data)
      .then((file:Blob) => {
        let urlDownload = this.boletoService.downloadPDF(file,`boletos_${moment().format('YYYY-MM-DD')}.pdf`);
        if(urlDownload != ''){
          urlExcel = urlDownload;
          this.ngxUiLoaderService.stop('2');
          return this.toastr.success('Se ha descargado con éxito el archivo Excel', '', { positionClass: 'toast-bottom-right' })
        }
          //
          var clasificacionesBoletaje=document.getElementsByClassName("clasificacionesBoletaje");

          this.total=0.0;
          this.saldo=0.0;
          this.transportistaService.getTransportistas().subscribe(data => {
            this.dataTransportistas = data;
            this.convenios = [];
          })
          for (let index = 0; index < clasificacionesBoletaje.length; index++) {
            const element = clasificacionesBoletaje[index]as  HTMLInputElement;
            element.value="0"
          }
    }).catch(error => {
      console.log(error);
      this.ngxUiLoaderService.stop('2');
      return this.toastr.error(`Por favor intenta de nuevo, ${error}`, 'Error al descargar', { positionClass: 'toast-bottom-right' })
    })
    .finally(() => {
      URL.revokeObjectURL(urlExcel);
    });
    }
        //
        var clasificacionesBoletaje=document.getElementsByClassName("clasificacionesBoletaje");

        this.total=0.0;
        this.saldo=0.0;
        this.operacionValida=false
        this.transportistaService.getTransportistas().subscribe(data => {
          this.dataTransportistas = data;
          this.convenios = [];
        })
        for (let index = 0; index < clasificacionesBoletaje.length; index++) {
          const element = clasificacionesBoletaje[index]as  HTMLInputElement;
          element.value="0"
        }
    this.ngxUiLoaderService.stop();
  }


  finished(type: string) {
    this.toastr.success(`${type} guardado con éxito`, '', { positionClass: 'toast-bottom-right' });
    this.id_scct_convenio=0;
    //this.router.navigate(['/dashboard/convenio']);
  }



  incrementarBoletos(id,monto, event){
    var nBoletos=Number(event.target.value);
    var totalAnteriorxVehiculo=0;
    if(this.boletos[id]){
      totalAnteriorxVehiculo=this.boletos[id]*parseFloat(monto);
      this.total=this.total-totalAnteriorxVehiculo;
    }else{
      this.boletos[id]=nBoletos;
    }

    this.total=this.total+(nBoletos*parseFloat(monto));
    this.boletos[id]=nBoletos;
    this.compararTotalSaldoaFavor(this.total,this.saldo);
  }

  insertBoleto(event, data: any) {
    let index = this.dataFormBoletos.findIndex(m => m.id_clasificacion === data.id);
    index === -1 ? this.dataFormBoletos.push({
      id_tarifa: data.id,
      id_clasificacion: data.vehiculo.id,
      cantidad: event.target.value,
    }) : this.dataFormBoletos[index].cantidad = event.target.value;

    console.log(this.dataFormBoletos);
  }
  private compararTotalSaldoaFavor(total, saldoaFavor){
    this.operacionValida=(total<=saldoaFavor && total>0);
  }

}
